import styled from 'styled-components'
import Colors from 'builder/styles/colors'
import Typography, { FontWeights } from 'builder/styles/typography'
import Shadows from 'builder/styles/shadows'

export const PTContainer = styled.div`
  display: flex;
  gap: 24px;
  width: 100%;
`

export const NavigationContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  border-radius: 12px;
  overflow: hidden;
  max-width: 352px;
  min-width: 300px;
  min-height: 332px;
  ${Shadows.lightWithBorder.low};
`

export const NavHeadingContainer = styled.div`
  display: flex;
  align-items: center;
`

export const ContentContainer = styled.div`
  flex: 1;
`

export const NavHeading = styled.h2`
  ${Typography.Caption}
  ${FontWeights.DemiBold}
  text-transform: uppercase;
  text-align: center;
  padding: 20px 0;
  flex: 1;
`

export const NavList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
`
export const NavListItem = styled.li<{ isActive: boolean }>`
  display: flex;
  align-items: center;
  gap: 12px;
  height: 64px;
  padding: 8px 20px;
  border-right: 3px solid transparent;
  cursor: pointer;
  color: ${Colors.Neutral90};
  ${Typography.Body}

  ${props =>
    props.isActive &&
    `
    color: ${props.theme.text};
    background-color: ${props.theme.soft}; 
    border-color: ${props.theme.base};
   `};
`

export const ServiceInfo = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const ServiceHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  ${Typography.Body}
  ${FontWeights.Regular}
  width: 100%;
`

export const ProgressBarContainer = styled.div<{ isActive: boolean }>`
  width: 100%;
  height: 4px;
  background-color: ${({ isActive, theme }) => (isActive ? theme.muted : Colors.Neutral10)};
  border-radius: 3px;
  overflow: hidden;
`

export const ProgressBarFiller = styled.div<{ progress: number }>`
  height: 100%;
  background-color: ${props => props.theme.base};
  width: ${({ progress }) => progress}%;
  transition: width 0.3s ease-in-out;
`

export const WidgetContainer = styled.div`
  flex: 2;
`

export const ButtonContainer = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding-right: 16px;
`

export const ExpandButton = styled.div`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background-color: ${Colors.Neutral10};
  display: flex;
  align-items: center;
  justify-content: center;
`
